//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class AddRuleConditionGroupModel extends ModelBase {
      static readonly $typeName = 'AddRuleConditionGroupModel';
      public conditionHashCodes: string[];
      public groupName: string;
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/AddRuleConditionGroupModel.ts